import { Divider, Stack } from "@mui/material";

export const SenderAndRecipientInfo = ({ originator, recipient }) => {
  return (
    <Stack justifyContent={"flex-start"} gap={0}>
      <div className="my-2 text-left">
        Sender Information
        <Divider />
      </div>
      <Stack justifyContent={"flex-start"} gap={0.5} sx={{ fontSize: 14 }}>
        <Stack mt={1} direction={"row"} gap={1}>
          <div>Sender: </div>
          <div className="text-black">
            <b>
              {originator?.firstName} {originator?.lastName}
            </b>
          </div>
        </Stack>
        <Stack direction={"row"} gap={1}>
          <div>Job Title: </div>
          <div className="text-black">{originator?.jobTitle ?? " - "}</div>
        </Stack>
        <Stack direction={"row"} gap={1}>
          <div>Email: </div>
          <div className="text-black">{originator?.email}</div>
        </Stack>
        <Stack direction={"row"} gap={1}>
          <div>Phone: </div>
          <div className="text-black">{originator?.phone}</div>
        </Stack>
        <Stack direction={"row"} gap={1}>
          <div>Practice: </div>
          <div className="text-black">{originator?.practiceName}</div>
        </Stack>
      </Stack>
      <div className="my-2 mt-4 text-left">
        Recipient Information
        <Divider />
      </div>
      <Stack justifyContent={"flex-start"} gap={0.5} sx={{ fontSize: 14 }}>
        <Stack mt={1} direction={"row"} gap={1}>
          <div>Recipient Practice: </div>
          <div className="text-black">
            <b>{recipient?.name}</b>
          </div>
        </Stack>
        <Stack direction={"row"} gap={1}>
          <div>Speciality: </div>
          <div className="text-black">{recipient?.speciality ?? " - "}</div>
        </Stack>
        <Stack direction={"row"} gap={1}>
          <div>Address: </div>
          <div className="text-black">
            {[
              recipient?.street,
              recipient?.street2,
              recipient?.city,
              recipient?.state,
              recipient?.zipCode,
            ]
              .filter(Boolean)
              .join(", ")}
          </div>
        </Stack>
        <Stack direction={"row"} gap={1}>
          <div>Email: </div>
          <div className="text-black">
            {recipient?.email?.length ? recipient.email : " - "}
          </div>
        </Stack>
        <Stack direction={"row"} gap={1}>
          <div>Phone: </div>
          <div className="text-black">{recipient?.phone}</div>
        </Stack>
      </Stack>
    </Stack>
  );
};
